export default __webpack_public_path__ + "static/media/of_2.9ad8fd27.mp3";